import { createFileRoute } from "@tanstack/react-router"

import { FeatureRequestsView } from "@/components/feature-requests/feature-requests-view"

export const Route = createFileRoute("/$dealership/feature-requests")({
  staticData: {
    breadcrumb: "Feature Requests",
  },
  component: FeatureRequestsLayout,
})

function FeatureRequestsLayout() {
  return (
    <div className="px-4 lg:px-6">
      <FeatureRequestsView />
    </div>
  )
}
